// extracted by mini-css-extract-plugin
module.exports = {"list":"OwnerRentals_list__RuNHk"};